import React, { Component, PropTypes } from 'react';

import './InviteForm.css';

class InviteForm extends Component {
  constructor(props) {
    super(props);

    this.state = { email: '', disabled: true };

    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(ev) {
    ev.preventDefault();

    let { email } = this.state;

    this.props.addInvite({ email });
    this.setState({email: '', disabled: true});
  }

  /**
   * Handle form input changes and update the `this.state` when a change
   * occurs. Maps checkbox input changes to a boolean, the rest use the raw
   * `value`. Also runs the resulting state through `this.validate()`, and
   * updates the `disabled` attribute to be the opposite of it's return value.
   *
   * @param {Event} ev - The onSubmit event for the React.DOM.Form.
   *
   * @memberOf InviteForm
   */
  handleFormInputChange(ev) {
    const { target } = ev;
    const value = target.value;
    const name = target.name;

    const state = this.state;
    let newState = Object.assign(state, { [name]: value });
    let disabled = !this.isValid(newState);

    this.setState({
      ...newState,
      disabled
    });
  }

  isValid(state) {
    const { email } = state;

    if (!email || email.trim().length === 0) {
      return false;
    }

    return true;
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="InviteForm">
        <input onChange={this.handleFormInputChange}
          value={this.state.email}
          type="email"
          name="email"
          className="form-input InviteForm__input"
          placeholder="email" />
        <input disabled={this.state.disabled} type="submit" className="Button Button--primary" value="Send" />
      </form>
    );
  }
};

InviteForm.propTypes = {
  addInvite: PropTypes.func.isRequired
};

export default InviteForm;



// WEBPACK FOOTER //
// ./src/components/InviteForm.js